/* ============================================================================
   CINTAS DE RESEÑAS (auto-scroll) — Cata·Kor / nmn_cata_kor
   Dos proyecciones de la MISMA fuente (window.LLS_REVIEWS del módulo nmn-resenas):
     - data-mode="fotos": una tarjeta por reseña CON foto (+ badge "✓ Verificado"
       solo si la reseña está verificada). Tap → lightbox existente del módulo.
     - data-mode="texto": una tarjeta por reseña (todas): estrellas + cita + nombre
       + verificado. Sin imagen.
   Marquee de loop infinito sin salto (track duplicado, translateX 0→-50%).
   Pausa: hover (desktop), pointer/touch, foco de teclado, botón manual.
   prefers-reduced-motion: sin auto-scroll → scroll nativo con snap + botón.
   No inventa datos: sin reseñas (o sin fotos en modo fotos) → la cinta se oculta.
   ========================================================================== */
(function () {
  if (window.__NMN_RVCAR_INIT) return;
  window.__NMN_RVCAR_INIT = true;

  var SEC_PER_CARD = 5;   // ~5 s por tarjeta
  var MIN_DUR = 22;       // duración mínima del ciclo (s)
  var MAX = 50;           // mismo tope que el módulo de reseñas

  function lls(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function starsHTML(rating) {
    var full = Math.round(rating || 0), out = '';
    for (var i = 1; i <= 5; i++) out += '<span class="rv-star' + (i <= full ? ' is-on' : '') + '">★</span>';
    return out;
  }
  function reviews() {
    return (window.LLS_REVIEWS || []).slice(0, MAX);
  }
  // Índice de una reseña con foto dentro del withImages del módulo (para el lightbox).
  function withImages() {
    return reviews().filter(function (r) { return r.image; });
  }

  // Pide a la CDN de Shopify un ancho acorde a la tarjeta (~160px @2x),
  // en vez del width=900 del módulo (evita descargar imágenes 8× más grandes).
  function thumbUrl(url) {
    if (!url) return url;
    if (/[?&]width=\d+/.test(url)) return url.replace(/([?&]width=)\d+/, '$1360');
    return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=360';
  }
  /* ---- tarjeta de cada modo ---- */
  function photoCard(r, imgIdx) {
    var badge = r.verified
      ? '<span class="lls-rvcar-badge">✓ Verificado</span>'
      : '';
    return '<button type="button" class="lls-rvcar-card lls-rvcar-photo" data-img-idx="' + imgIdx + '" aria-label="Ver reseña de ' + lls(r.name) + '">' +
      '<img src="' + lls(thumbUrl(r.image)) + '" alt="Reseña de ' + lls(r.name) + '" loading="lazy">' +
      badge +
      '</button>';
  }
  function quoteCard(r) {
    var verified = r.verified ? '<span class="rv-verified lls-rvcar-ver">✓ Verificado</span>' : '';
    var quote = r.text || r.title || '';
    return '<article class="lls-rvcar-card lls-rvcar-quote" tabindex="0">' +
      '<div class="rv-card-stars lls-rvcar-stars">' + starsHTML(r.rating) + '</div>' +
      '<p class="lls-rvcar-text">' + lls(quote) + '</p>' +
      '<div class="lls-rvcar-foot">' +
        '<span class="lls-rvcar-name">' + lls(r.name) + '</span>' + verified +
      '</div>' +
      '</article>';
  }

  /* ---- construye una cinta ---- */
  function build(root) {
    var mode = root.getAttribute('data-mode') === 'fotos' ? 'fotos' : 'texto';
    var viewport = root.querySelector('[data-rvcar-viewport]');
    var track = root.querySelector('[data-rvcar-track]');
    if (!viewport || !track) return;

    var all = reviews();
    var cards = [];
    if (mode === 'fotos') {
      var verifiedOnly = root.getAttribute('data-verified-only') === 'true';
      var imgs = withImages(); // orden idéntico al state.withImages del módulo
      imgs.forEach(function (r, i) {
        if (verifiedOnly && !r.verified) return;
        cards.push(photoCard(r, i)); // i = índice real en withImages (para el lightbox)
      });
    } else {
      all.forEach(function (r) { cards.push(quoteCard(r)); });
    }

    // Sin material → ocultar la sección entera (no renderiza nada falso).
    if (!cards.length) { root.hidden = true; return; }
    root.hidden = false;

    var secPer = parseFloat(root.getAttribute('data-speed')) || SEC_PER_CARD;
    var oneSet = cards.join('');

    // Setup SINCRÓNICO: duplicar el set (loop -50% sin salto) y fijar duración.
    // No depende de medir el viewport, así el marquee queda armado aunque rAF
    // se retrase o el ancestro esté momentáneamente oculto.
    track.innerHTML = oneSet + oneSet;
    track.style.animationDuration = Math.max(MIN_DUR, cards.length * secPer) + 's';
    track.setAttribute('data-rvcar-ready', '1');
    wireInteractions(root, track);

    // Mejora best-effort: si UN set no llena el viewport (pocas tarjetas), engrosar
    // para que no quede un hueco visible en el loop. Requiere layout medible.
    requestAnimationFrame(function () {
      if (!viewport.clientWidth) return;
      var oneW = track.scrollWidth / 2; // ancho de un set (hay 2 copias)
      if (oneW >= viewport.clientWidth || oneW <= 0) return;
      var reps = Math.max(2, Math.ceil((viewport.clientWidth / oneW) + 0.5));
      var grown = '';
      for (var k = 0; k < reps; k++) grown += oneSet;
      track.innerHTML = grown + grown;
      track.style.animationDuration = Math.max(MIN_DUR, cards.length * reps * secPer) + 's';
    });

    // Delegación de tap para el modo fotos → lightbox del módulo existente.
    if (mode === 'fotos') {
      track.addEventListener('click', function (e) {
        var btn = e.target.closest ? e.target.closest('.lls-rvcar-photo') : null;
        if (!btn) return;
        var idx = parseInt(btn.getAttribute('data-img-idx'), 10);
        var rv = window.__NMN_RV;
        if (rv && typeof rv.openLightbox === 'function' && idx >= 0) rv.openLightbox(idx);
      });
    }
  }

  /* ---- pausa: hover, touch/pointer, foco, botón manual ---- */
  function wireInteractions(root, track) {
    var paused = false;      // pausa manual (botón) — persistente
    var transient = false;   // pausa transitoria (hover/touch/foco)
    function apply() {
      track.style.animationPlayState = (paused || transient) ? 'paused' : 'running';
    }
    var viewport = root.querySelector('[data-rvcar-viewport]');

    // Desktop hover (además del :hover CSS, por si el botón cambia el estado)
    viewport.addEventListener('mouseenter', function () { transient = true; apply(); });
    viewport.addEventListener('mouseleave', function () { transient = false; apply(); });
    // Touch / pointer: pausar mientras se toca
    viewport.addEventListener('pointerdown', function () { transient = true; apply(); });
    ['pointerup', 'pointercancel', 'pointerleave'].forEach(function (ev) {
      viewport.addEventListener(ev, function () { transient = false; apply(); });
    });
    viewport.addEventListener('touchstart', function () { transient = true; apply(); }, { passive: true });
    ['touchend', 'touchcancel'].forEach(function (ev) {
      viewport.addEventListener(ev, function () { transient = false; apply(); }, { passive: true });
    });
    // Foco de teclado dentro de la cinta
    viewport.addEventListener('focusin', function () { transient = true; apply(); });
    viewport.addEventListener('focusout', function () { transient = false; apply(); });

    // Botón manual pausar/reanudar
    var btn = root.querySelector('[data-rvcar-toggle]');
    if (btn) {
      btn.addEventListener('click', function () {
        paused = !paused; apply();
        btn.setAttribute('aria-pressed', paused ? 'true' : 'false');
        btn.classList.toggle('is-paused', paused);
        var lbl = paused ? 'Reanudar' : 'Pausar';
        btn.setAttribute('aria-label', lbl + ' el carrusel');
        var t = btn.querySelector('[data-rvcar-toggle-txt]');
        if (t) t.textContent = paused ? 'Reanudar' : 'Pausar';
      });
    }
  }

  function initAll(scope) {
    var roots = (scope || document).querySelectorAll('[data-lls-rvcar]');
    Array.prototype.forEach.call(roots, function (root) {
      if (root.getAttribute('data-rvcar-done') === '1') return;
      root.setAttribute('data-rvcar-done', '1');
      build(root);
    });
  }

  function boot() { initAll(document); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  // Editor de Shopify: reconstruir al agregar/editar la sección en vivo.
  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target && e.target.querySelector ? e.target.querySelector('[data-lls-rvcar]') : null;
    if (el) { el.removeAttribute('data-rvcar-done'); initAll(e.target); }
  });
})();
